import getScenarioStore from './getScenarioStore';
import { SearchScenarioId } from '../store/schema/SearchScenarioId';

export default function getSearchBoxWidth(scenarioId: SearchScenarioId): number {
    return getScenarioStore(scenarioId).searchBoxWidth;
}
